module.exports = __webpack_public_path__ + "media/images/use_cases/mobile_app_testing-8bc7f45d190a369bf8a84b057357de0a.svg";